import React from "react";
import { useTranslation } from "react-i18next";
import AdnTable from "../common/adnTable/AdnTable";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import { DatePicker, Row, Col, Button } from "antd";
import moment from "moment";
import "./ManageFollowUpEventStatusListPage.css";
import CaptionComponent from "../common/adnCaptionComponent/AdnCaptionComponent";
import { getDoneEventsReport } from "../../api/FollowUpEventApi";
import { ExportOutlined } from "@ant-design/icons";
import AdnMessageError from "../common/adnMessage/AdnMessageError";

function FollowUpEventStatusListForm({
  columns,
  followUpEventsStatusData,
  loading,
  onSelectDateRange,
  startDate,
  endDate,
}) {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;

  const REPORT_NAME = t("followUpEventStatusForm.reports.doneEvents");

  const generateDoneEventsReport = async () => {
    await getDoneEventsReport(startDate, endDate)
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const a = document.createElement("a");
        a.href = url;
        a.download = `${REPORT_NAME}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        AdnMessageError(
          t("followUpEventStatusForm.messages.couldNotGenerateReport")
        );
      });
  };

  return (
    <>
      <AdnPageTitle title={t("followUpEventStatusForm.title")} />
      <AdnCard loading={loading}>
        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 8 }}
            xxl={{ span: 8 }}
          >
            <Row className="RangePicker">
              <RangePicker
                picker="month"
                onChange={onSelectDateRange}
                defaultValue={[moment(startDate), moment(endDate)]}
              />
            </Row>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 8 }}
            xxl={{ span: 8 }}
          >
            <Row className="reportDoneEventsButton">
              <Button
                className="adn-primary-button"
                type="submit"
                onClick={generateDoneEventsReport}
              >
                <ExportOutlined /> {t("followUpEventStatusForm.buttons.export")}
              </Button>
            </Row>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 9 }}
            xl={{ span: 8 }}
            xxl={{ span: 8 }}
          >
            <CaptionComponent
              className="LegendComponent"
              iconColor="blue"
              text={t("followUpEventStatusForm.labels.eventsDoneAssigned")}
              isBold={true}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <AdnTable
              scroll={{ x: "max-width" }}
              bordered
              columns={columns}
              data={followUpEventsStatusData}
              pagination={false}
            />
          </Col>
        </Row>
      </AdnCard>
    </>
  );
}

export default FollowUpEventStatusListForm;
